<script>
import { debounce } from "@/utils/helper"
import { mapState } from "vuex"
export default {
  name: "TableMixin",
  props: {
    userId: {
      type: String,
      required: false,
    },
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    footer() {
      return {
        "items-per-page-all-text": this.$t("pagination.all"),
        "items-per-page-text": this.$t("pagination.row_per_page"),
        itemsPerPageText: this.$t("pagination.row_per_page"),
        pageText: "{0}-{1} sur {2}",
      }
    },
    ...mapState("theme", ["color"]),
  },
  mounted() {
    this.initialize()
  },

  current_user() {
    return this.$store.state.user.profile
  },

  data: function () {
    return {
      loading: false,
      search: "",
      options: {},
      user_id_local: null,
      params: {},
      afterLoadEnable: false,
      data: [],
    }
  },
  methods: {
    initialize() {
      console.log("MOUNTED TABLE MIXIN")
      this.user_id_local = this.userId
      if (this.$route.params.user_id) {
        this.user_id_local = this.$route.params.user_id
      }
      this.getDataFromApi()
    },
    afterLoad() {},
    debounceFetchApi: debounce(async function () {
      await this.getDataFromApi()
    }, 1000),

    async remove(path, item) {
      await this.$store.dispatch(path + "/DELETE", item)
      this.$toast.success(this.$t("success.item_deleted"))
      return true
    },
    async getDataFromApi() {
      this.loading = true
      const { page, itemsPerPage, sortBy, sortDesc } = this.options
      this.FETCH({
        ...(this.params && this.params),
        ...(page && {
          offset: (page - 1) * itemsPerPage,
        }),
        limit: itemsPerPage,
        ...(this.search && {
          keyword: this.search,
        }),
        ...(this.user_id_local && {
          user_id: this.user_id_local,
        }),
        ...(sortBy &&
          sortBy.length && {
            sort_field: sortBy[0],
            sort: sortDesc[0] ? "desc" : "asc",
          }),
      })
        .then((res) => {
          this.data = res.data
        })
        .finally(() => {
          if (this.afterLoadEnable) {
            this.afterLoad()
            this.afterLoadEnable = false
          }
          this.loading = false
        })
    },
  },
  watch: {
    options(val, oldVal) {
      if (Object.keys(oldVal).length !== 0) {
        console.log("GET DATA " + val)
        this.debounceFetchApi()
      }
    },
    search() {
      console.log("Search")
      this.debounceFetchApi()
    },
    user_id(val) {
      this.user_id_local = val
      console.log("GET DATA USER " + val)

      this.debounceFetchApi()
    },
  },
}
</script>
